import { Base64 } from 'js-base64';

class Storage {
  constructor(type) {
    this.storage = {
      local: window.localStorage,
      session: window.sessionStorage
    }[type];
  }

  set(key, val) {
    this.storage.setItem(key, Base64.encode(JSON.stringify(val)));
  }

  get(key) {
    const value = this.storage.getItem(key);
    return value ? JSON.parse(Base64.decode(value)) : null;
  }

  remove(key) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }
}

export const ls = new Storage('local');
export const ss = new Storage('session');
